app = angular.module('harriApp');
app.controller('userMediaController',function(){

});